import { render, staticRenderFns } from "./CookiesPolicy.vue?vue&type=template&id=7ba64a4a&scoped=true&"
import script from "./CookiesPolicy.vue?vue&type=script&lang=js&"
export * from "./CookiesPolicy.vue?vue&type=script&lang=js&"
import style0 from "./CookiesPolicy.vue?vue&type=style&index=0&id=7ba64a4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba64a4a",
  null
  
)

export default component.exports